import { useCallback, useContext, useEffect } from 'react';

import { Table } from 'antd';

import { PaymentMethodLife, SumTotal } from './components';
import { QuotationStepButtons } from '../../../shared';

import { QuotationInfoContext} from '../../../shared/contexts';
import { StepTwoFormContext } from '../StepTwo/contexts/StepTwoForm';
import { StepThreeFormContext } from './contexts/StepThreeForm';

import { QUOTATION_BUTTON, QuotationStep } from '../../../shared/interfaces';
import { ContentSection } from '../../../../../../../shared/components';
import { DECISION_TYPE } from '../../../../../../../shared/interfaces';

const MOCK_TABLE_COLUMNS_HEADER = [
  {
    title: 'Suma asegurada por persona',
    dataIndex: 'sumAssured',
    width: '50%',
    key: 'sumPerPerson',
  },
  {
    title: 'Prima',
    dataIndex: 'prima',
    width: '50%',
    key: 'prima',
  },
];

const HEADER_RIGHT_EMISSION = [
  {
    title: 'Descripción',
    dataIndex: 'sumAssured',
    width: '50%',
    key: 'sumPerPerson',
  },
  {
    title: 'Prima',
    dataIndex: 'prima',
    width: '50%',
    key: 'prima',
  },
];

export const StepThree = () => {
  const { setCurrentStep } = useContext(QuotationInfoContext);

  const { stepTwoForm } = useContext(StepTwoFormContext);

  const {
    isPersonalDomestic,
    labelButton,
    quotationResponse,
    rightEmissionLife,
    setIsPersonalDomestic,
    setLabelButton,
    sumInsuredByPerson,
    handleOnClickQuotation,
  } = useContext(StepThreeFormContext);

  const onPressBackButton = useCallback(() => {
    if (quotationResponse) setLabelButton(QUOTATION_BUTTON.RECOTIZAR);

    setCurrentStep(QuotationStep.TWO);
  }, [setCurrentStep, setLabelButton, quotationResponse]);

  const setFieldPersonalDomestic = useCallback(() => {
    const personalDomesticSelected =
      stepTwoForm?.getFieldValue('personalDomestic');

    if (personalDomesticSelected === DECISION_TYPE.YES) {
      setIsPersonalDomestic(true);
      return;
    }
    setIsPersonalDomestic(false);
  }, [
    stepTwoForm,
    setIsPersonalDomestic,
  ]);


  const validateForm = useCallback(async () => {
    if (
      labelButton === QUOTATION_BUTTON.COTIZAR ||
      labelButton === QUOTATION_BUTTON.RECOTIZAR
    ) {
      return handleOnClickQuotation();
    }

    setCurrentStep(QuotationStep.FOUR);
  }, [
    labelButton,
    handleOnClickQuotation,
    setCurrentStep
  ]);

  const handleValuesChange = useCallback((changedValues: any) => {
    if (quotationResponse && changedValues) {
      setLabelButton(QUOTATION_BUTTON.RECOTIZAR);
    }
  }, [
    quotationResponse,
    setLabelButton,
  ]);

  useEffect(() => {
    setFieldPersonalDomestic();
  }, [setFieldPersonalDomestic]);


  return (
    <>
      <ContentSection
        level='h3'
        title='Sumas Aseguradas por Persona'
        hasCard={false}
      >
        <Table
          bordered
          className='w-100'
          columns={MOCK_TABLE_COLUMNS_HEADER}
          dataSource={sumInsuredByPerson}
          pagination={false}
        />
      </ContentSection>

      {!(isPersonalDomestic) && (
        <ContentSection
          level='h3'
          title='Derechos de Emisión'
          hasCard={false}
        >
          <Table
            bordered
            className='w-100'
            columns={HEADER_RIGHT_EMISSION}
            dataSource={rightEmissionLife}
            pagination={false}
          />
        </ContentSection>
      )}

      {quotationResponse && (
        <PaymentMethodLife handleValuesChange={handleValuesChange} />
      )}

      {labelButton === QUOTATION_BUTTON.EMITIR && (
        <SumTotal dataQuotation={quotationResponse} />
      )}

      <QuotationStepButtons
        label={labelButton}
        onClick={validateForm}
        onPressBackButton={onPressBackButton}
      />
    </>
  );
};
